import { makeStyles } from '@material-ui/core/styles';

import { COLORS, FONTS } from 'src/data/ui';

const MOCK_HEIGHT = 900;

const calcRelativeToDVHSize = (pxSize) => `${(100 * pxSize) / MOCK_HEIGHT}dvh`;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: calcRelativeToDVHSize(480),
      height: calcRelativeToDVHSize(900),
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      justifyContent: 'center',
      backgroundImage: 'linear-gradient(166deg, #006BFF -0.97%, #022CC1 77.49%);',
    },
    centerWrapper: {},
    text: {
      color: COLORS.gray.white,
      textAlign: 'center',
      fontFamily: FONTS.DMSans,
      fontSize: calcRelativeToDVHSize(48),
      lineHeight: calcRelativeToDVHSize(50),
      fontWeight: 900,
    },
    imgSuggestions: {
      margin: theme.spacing(calcRelativeToDVHSize(48), 'auto', 0),
      width: calcRelativeToDVHSize(360),
      height: calcRelativeToDVHSize(370),
      objectFit: 'contain',
    },
    imgTrusted: {
      position: 'absolute',
      bottom: calcRelativeToDVHSize(32),
      alignSelf: 'center',
      width: calcRelativeToDVHSize(349),
      height: calcRelativeToDVHSize(101),
      objectFit: 'contain',
    },
  }),
  { name: 'AuthenticationBanner' }
);
